var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00022 1.7998C6.01788 1.7998 3.60022 4.21747 3.60022 7.1998V10.427L2.96383 11.0634C2.70643 11.3208 2.62943 11.7079 2.76873 12.0442C2.90803 12.3805 3.23621 12.5998 3.60022 12.5998H14.4002C14.7642 12.5998 15.0924 12.3805 15.2317 12.0442C15.371 11.7079 15.294 11.3208 15.0366 11.0634L14.4002 10.427V7.1998C14.4002 4.21747 11.9826 1.7998 9.00022 1.7998Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0002 16.1998C7.50903 16.1998 6.3002 14.991 6.3002 13.4998H11.7002C11.7002 14.991 10.4914 16.1998 9.0002 16.1998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/notify.064cbec97077c696316d5d9bfc911359.svg";
export { ForwardRef as ReactComponent };